type CursorOverlayProps = {
  position: { x: number; y: number } | null;
  showPing: boolean;
  viewport: string | null;
};

export default function CursorOverlay({ position, showPing, viewport }: CursorOverlayProps) {
  if (!position) {
    return null;
  }

  if (viewport === "mobile") {
    return (
      <div
        className="pointer-events-none absolute z-20 -translate-x-1/2 -translate-y-1/2 transition-all duration-700 ease-out"
        style={{ left: `${position.x}%`, top: `${position.y}%` }}
      >
        <span
          className="block h-8 w-8 rounded-full border-2 border-white bg-gray-700/70 shadow-sm"
          aria-hidden="true"
        />
        {showPing ? (
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="h-12 w-12 animate-ping rounded-full border-2 border-primary opacity-75" />
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div
      className="pointer-events-none absolute z-20 -translate-y-[3px] transition-all duration-700 ease-out"
      style={{ left: `${position.x}%`, top: `${position.y}%` }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M2 2L12 22L14 14L22 12L2 2Z" fill="white" stroke="black" strokeWidth="2" />
      </svg>
      {showPing ? (
        <div className="absolute left-2 top-2 -translate-x-1/2 -translate-y-1/2">
          <div className="h-12 w-12 animate-ping rounded-full border-2 border-primary opacity-75" />
        </div>
      ) : null}
    </div>
  );
}
